import Vue from 'vue';
import { Model } from 'vue-api-query';

Model.$http = Vue.http;
